import React, { useState } from "react";
import TemplateModal from "./TemplateModal";

export default function ReccepptModal() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <button
        onClick={() => setIsModalOpen(true)}
        className="bg-blue-600 text-white px-6 py-3 rounded hover:bg-blue-700 shadow-lg"
      >
        Open Template Modal
      </button>

      <TemplateModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
}
